import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { disableSentry, initializeSentry } from '@config/sentry'
import { usePrivacyPreferences } from '@contexts/PrivacyPreferencesContext'
import cache from '@utils/cache'
import {
  clearAnalyticsBrowserStorage,
  disableOfflineExperience,
  enableOfflineExperience
} from '@/privacy/optionalRuntime'
import { isSensitiveTelemetryRoute } from '@/privacy/telemetrySanitizer'

function PrivacyRuntime() {
  const { categories } = usePrivacyPreferences()
  const location = useLocation()
  const diagnosticsAllowed =
    categories.analytics &&
    !isSensitiveTelemetryRoute(`${location.pathname}${location.search}`)

  useEffect(() => {
    if (diagnosticsAllowed) {
      if (import.meta.env.PROD) void initializeSentry()
      return undefined
    }

    clearAnalyticsBrowserStorage()
    void Promise.resolve(disableSentry()).finally(clearAnalyticsBrowserStorage)
    return undefined
  }, [diagnosticsAllowed])

  useEffect(() => {
    if (categories.experience) {
      void enableOfflineExperience()
      return undefined
    }

    cache.clear()
    void disableOfflineExperience()
    return undefined
  }, [categories.experience])

  return null
}

export default PrivacyRuntime
